<div class="flex align-items-center flex-wrap mb-4">
  <div class="text-800 text-2xl font-medium mr-4">{{ 'EIM_TITLE' | translate }}</div>
  <div class="border-round-2xl px-2 py-1" [ngStyle]="{ backgroundColor: greyColor, color: whiteColor }">{{retestString}}</div>
  <div class="mt-4" [innerHTML]="eimText"></div>
  <p class="underline">{{ retestText }}</p>
</div>
